import { ConsoleLogger, request } from '@nextgen-web-framework/core';
import { getAprApiReqObj } from '../../config/aprEndPoints';
import { AprData, AprProps } from './types/propTypes';

export const aprApi = {
  async getProductIdsByAPR(aprProps: AprProps): Promise<string[]> {
    try {
      const requestOptions = getAprApiReqObj(aprProps);
      const data: AprData = await request<AprData>(requestOptions);

      ConsoleLogger.log('APR API RESPONSE - ', data);
      const productIds = data?.recommendations?.map((recommendation) => recommendation.sku) || [];
      return Promise.resolve(productIds);
    } catch (error) {
      ConsoleLogger.log('APR SERVICE FAILED WITH ERROR - ', error);
      return Promise.reject(error);
    }
  },
};

export type { AprData, AprProps };
